import React from 'react'
import { capitalize } from 'lodash'

import DataGrid from '../UI/DataGrid'
import { Formula } from '../UI/FormulaTokens'
import FormulaCard from './FormulaCard'
import formattedReferences from './formattedReferences'

const ListFormulas = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'formulaType', title: 'Type' },
    { name: 'formattedValue', title: 'Value' },
    { name: 'dependentOn', title: 'Dependent on' }
  ]

  const gridRowMappingFn = formula => {
    const id = formula.id
    const { name, formulaType, formattedValue } = formula.attributes

    const formulaComponent = (
      <Formula formulaType={formulaType} value={formattedValue} />
    )

    return {
      id: id,
      name: name,
      formulaType: capitalize(formulaType),
      formattedValue: formulaComponent,
      dependentOn: formattedReferences(formula)
    }
  }

  const gridSorting = [{ columnName: 'name', direction: 'asc' }]
  const sortingStateColumnExtensions = [
    { columnName: 'formattedValue', sortingEnabled: false },
    { columnName: 'dependentOn', sortingEnabled: false }
  ]

  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false }
  ]

  const filteringStateColumnExtensions = [
    { columnName: 'formattedValue', filteringEnabled: false },
    { columnName: 'dependentOn', filteringEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'formulaType', width: 150 },
    { columnName: 'formattedValue', width: 200 },
    { columnName: 'dependentOn', width: 200 }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="formulas"
      resourceSingularName="formula"
      resourcePluralName="formulas"
      nameAttribute="name"
      clientRootPath="/formulas"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      tableColumnExtensions={tableColumnExtensions}
      filteringStateColumnExtensions={filteringStateColumnExtensions}
      sortingStateColumnExtensions={sortingStateColumnExtensions}
      detailsCard={FormulaCard}
    />
  )
}

export default ListFormulas



// WEBPACK FOOTER //
// ./src/components/Formulas/ListFormulas.jsx